import { PM_EVENT } from '../postMessage/constants'
import { sendPostMessage } from '../postMessage/utils'
import { isInIframe } from './iframe'

// Matches logic in React's `shared/ExecutionEnvironment` file
// https://github.com/facebook/react/blob/9cdf8a99edcfd94d7420835ea663edca04237527/packages/shared/ExecutionEnvironment.js

export const canUseWindow = !!(
  typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
)

export const sendEmail = (recipients?: string | string[]) => {
  if (!recipients || !recipients?.length) return

  if (Array.isArray(recipients)) {
    recipients = recipients.join(',')
  }

  if (isInIframe()) {
    return sendPostMessage(PM_EVENT.MAILTO, { recipients })
  }

  const tempAnchorElement = document.createElement('a')
  tempAnchorElement.setAttribute('href', `mailto:${recipients}`)
  tempAnchorElement.setAttribute('target', `_blank`)
  tempAnchorElement.setAttribute('rel', 'nofollow noreferrer noopener')

  tempAnchorElement.click()
}
